<template>
  <main
    id="app"
    :class="{ 'dark': isFunnel }"
  >
    <!-- heroVisibility="hide" -->
    <MainHeader />

    <transition name="fade" mode="out-in">
      <router-view  />
    </transition>

    <StartForm 
      v-if="notInContact && notInFunnel" />

    <Footer
      v-if="notInFunnel" />
  </main>
</template>

<script>
import MainHeader from "@/partials/MainHeader.vue";
import Footer from "@/partials/Footer.vue";
import StartForm from "@/components/form/StartForm.vue";

export default {
  components: {
    MainHeader,
    StartForm,
    Footer
  },
  created() {
    if (!localStorage.getItem("user-lang")) {
      const userLang = navigator.language || navigator.userLanguage;
      const langConverted = userLang.split("-")[0];
      localStorage.setItem("user-lang", langConverted);
    }
  },
  computed: {
    notInFunnel: function() {
      return this.$route.name && !this.$route.name.includes('step-')
    },
    notInContact: function() {
      return this.$route.name != 'contacts'
    },
    isFunnel: function() {
      return !this.notInFunnel;
    }
  }
};
</script>

<style>

.dark {
  background-color: #409DAE;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

